import React, { FC, ReactNode } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400 text-justify">
            The Black Rock team are adventure loving people with a mission to
            make your visit to Southern Utah & the Hawaiian Islands simplistic
            as possible.
            <br /> Founder, Nate Derring, has a background as an Automobile
            Dealership owner and personally handpicks & reviews every car that
            enters the Black Rock Rental fleet. When you book with Black Rock
            you can be assured that you’re getting a quality vehicle and a
            friendly communicative staff that will assist in making your travels
            a breeze. With over 10,000 rental trips under their belt, Black Rock
            is the most experienced team to take care of your during your visit.
          </span>
          {!!btnText && <ButtonPrimary href="/signup">{btnText}</ButtonPrimary>}
        </div>
        <div className="flex-grow">
          <img className="w-full  rounded-xl" src={rightImg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
